import { Text } from '@grovus/design-system'

/** A section label inside a header disclosure panel. Shared so the two panels agree. */
export function PanelHeading({ children }: { children: string }) {
  return (
    <Text fz={10} tt="uppercase" className="grv-muted" style={{ letterSpacing: '0.1em' }} mb="sm">
      {children}
    </Text>
  )
}
